module.exports = __webpack_public_path__ + "static/assets/745ef64178d1022f8cc31cb6af0877cc.svg";